<template>
  <div class="com-main-container">
    <div class="com-main-container-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name:'ComContainer'
}
</script>

<style lang='less' scoped>
.com-main-container{
    width: 100%;
    background-color: #F6F6F6;
    overflow: hidden;
}
.com-main-container-content {
    margin: 24px auto 36px;
    width: 1248px;//1180
}
</style>